module.exports = __webpack_public_path__ + "static/img/up-vote.d6de80bb.svg";